import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logo, title } from '../Config/Config';
import { OpenInNew } from '@mui/icons-material';
import { Cookies } from 'typescript-cookie';
import { HeaderItem, HeaderItemtools } from '../AllContent/Content';
import toasted from '../Config/toast';
import { Offcanvas } from 'react-bootstrap';
import BottomBar from './BottomBar';
import BuyMeACoffee from '../Config/BuyMeACoffee';


const Header = () => {
     const navigate = useNavigate();
     // const location = useLocation();
     // const auth = getCookie("auth");


     // const handleLogout = () => {
     //      Cookies.remove("auth");
     //      toasted.error("You have been logged out.");
     //      navigate("/login");
     // };


     useEffect(() => {
          const handleLogout = () => {
               Cookies.remove("auth");
               toasted.error("You have been logged out.");
               navigate("/login");
          };

          const startLogoutTimer = () => {
               setTimeout(() => {
                    handleLogout();
               }, 5 * 60 * 60 * 1000); // 5 hours
          };

          startLogoutTimer();

          return () => {
               // Clear timeout if necessary
          };
     }, [navigate]); 



     const [show, setShow] = useState(false);
     const handleClose = () => setShow(false);
     const handleShow = () => setShow(true);


     const [visible, setVisible] = useState(true);
     const [lastScrollY, setLastScrollY] = useState(0);

     useEffect(() => {
          const handleScroll = () => {
               if (window.scrollY > lastScrollY) {
                    // Scroll down
                    setVisible(false);
               } else {
                    // Scroll up
                    setVisible(true);
               }
               setLastScrollY(window.scrollY);
          };

          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
     }, [lastScrollY]);

     return (
          <>

               <header className={`header ${visible ? 'show' : 'hide'}`} id='header-banner'>
                    <div className='__container' >
                         <Link to="/" className='_logo'>
                              <img src={logo} alt={title + "logo"} />
                         </Link>
                         <BuyMeACoffee/>

                         <div className='__list'>
                              <ul className='nav'>

                                   {HeaderItem.map((item, index) => (
                                        <li className='nav-item ' key={index}>
                                             {item.button ?
                                                       <Link to={item.path}  target="_blank" className="nav-button "> {item.label} </Link>
                                                  :
                                                  item.inout ?
                                                       <Link to={item.path} className="nav-link"> {item.label} </Link>
                                                       :
                                                       item.exLink ?
                                                            <Link to={'#'} onClick={handleShow} className="nav-link"> {item.label} </Link>
                                                            :
                                                            <Link to={item.path} className="nav-link"> {item.label} </Link>

                                             }
                                        </li>
                                   ))}
                              </ul>
                              

                         </div>
                    </div>
               </header>

               <div className='grain'></div>




               <Offcanvas show={show} onHide={handleClose} placement="start" scroll={false} backdrop={true} className="header-off-canvas">
                    <Offcanvas.Header closeButton>
                         <Offcanvas.Title>Tools</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                         <ul>
                              {HeaderItemtools.map((item, index) => {
                                   return (
                                        <li className='nav-item' key={index}>
                                             <Link to={item.path} className='nav-link' target='_self' onClick={handleClose}>

                                                  <p> <span> {item.icon} </span> {item.label}</p>
                                                  <OpenInNew className='__extrnal_link' /></Link>
                                        </li>
                                   )
                              })}
                         </ul>

                         {HeaderItemtools.length > 5 && (
                              <div className='__footer-off'>
                                   <h5> Scroll Down seen More tools  </h5>
                              </div>
                         )}
                    </Offcanvas.Body>
               </Offcanvas>

               <BottomBar handleShow={handleShow} />
          </>

     );
}

export default Header;
